import { useState, useEffect, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import cn from 'classnames';

import SocialLInks from '../SocialLInks/SocialLInks';
import Sidebar from '../Sidebar/Sidebar';
import styles from './MainHeader.module.css';

const MainHeader = (props) => {
  const { userData } = props;
  // console.log('===userData', userData);

  const [showMenu, setShowMenu] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  // const [showSidebar, setShowSidebar] = useState(true);

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const userName = useMemo(() => {
    if (userData?.user?.name) {
      const { name } = userData.user;
      const nameParts = name.split(' ');
      const [firstName, lastName = ''] = nameParts;
      return firstName[0] + lastName[0];
    }
    return 'AR';
  }, [userData]);

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current && !menuRef.current.contains(event.target)
        && buttonRef.current && !buttonRef.current.contains(event.target)
      ) {
        hideMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      hideMenu();
      // document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const hideMenu = () => {
    document.body.style.overflow = 'auto';
    setShowMenu(false);
  };

  const showMenuHandler = (event) => {
    event.stopPropagation(); 
    document.body.style.overflow = showMenu ? 'auto' : 'hidden';
    setShowMenu(!showMenu);
  };

  return (
    <>
      <header className={styles.header}>
        <Link className={styles.logo} to="/" />
        <div className={styles.rightPart}>
          <div 
            ref={buttonRef}
            className={styles.mobileMenu} 
            onClick={showMenuHandler} 
          />
          <nav 
            ref={menuRef}
            className={cn(styles.menuWrapper, { [styles.showMenu]: showMenu })}
          >
            <ul className={styles.menu}>
              <li className={styles.menuItem}>
                <NavLink
                  to="/blog"
                  className={styles.menuLink}
                >
                  Blog
                </NavLink>
              </li>
              <li className={styles.menuItem}>
                <NavLink
                  to="/contact"
                  className={styles.menuLink}
                >
                  Contacts
                </NavLink>
              </li>
              {!userData && (
                <li className={styles.menuItem}>
                  <NavLink
                    to="/get-meal-plan"
                    className={styles.menuLink}
                  >
                    Get your meal plan
                  </NavLink>
                </li>
              )}
              {!!userData && (
                <li className={styles.menuItem}>
                  <NavLink
                    to="/basket"
                    className={styles.menuLink}
                  >
                    Basket
                  </NavLink>
                </li>
              )}
              <li className={styles.social}>
                <SocialLInks />
              </li>
            </ul>
          </nav>
          <div className={styles.rightButtons}>
            <Link className={styles.menuButton} to="/get-app">
              Get App
            </Link>
            {!!userData && (
              <div className={styles.userButton} onClick={() => setShowSidebar(true)}>
                {userName}
              </div>
            )}
          </div>
        </div>
      </header>
      {showSidebar && <Sidebar onHide={() => setShowSidebar(false)} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
});

export default connect(mapStateToProps)(MainHeader);
